import { defineAsyncComponent } from 'vue'

export default app => {
  app.component('PlatformCustomersCompanyUserForm', defineAsyncComponent(() => import('./CompanyUserForm')))
  app.component('PlatformCustomersCompanyUserPage', defineAsyncComponent(() => import('./CompanyUserPage')))
  app.component('PlatformCustomersCompanyUsersPage', defineAsyncComponent(() => import('./CompanyUsersPage')))
  app.component('PlatformCustomersMyCompaniesPage', defineAsyncComponent(() => import('./MyCompaniesPage')))
  app.component('PlatformCustomersCompanyUserReinvitePage', defineAsyncComponent(() => import('./CompanyUserReInvitePage')))
}
